import VisibilitySensor from 'react-visibility-sensor';
import { useSelector } from 'react-redux';

import fetchApi from 'hooks/fetchApi';
import appState from 'hooks/appState';
import { APP_STATE } from 'types';
import API_NAME from 'services/api';
import { ISensor } from './ISensor';

const Sensor = ({ children, id }: ISensor) => {
  const appStateStore = useSelector((store) => store.app);
  const appStateAction = appState();

  const { action } = fetchApi();

  const handleChnage = (v) => {
    if (v && !appStateStore[APP_STATE.POST_SENSOR_ID]?.data?.includes(id)) {
      if (appStateStore[APP_STATE.POST_SENSOR_ID]?.data) {
        appStateAction(APP_STATE.POST_SENSOR_ID, {
          data: [...appStateStore[APP_STATE.POST_SENSOR_ID]?.data, id],
        });
      } else {
        appStateAction(APP_STATE.POST_SENSOR_ID, {
          data: [id],
        });
      }
      action(
        API_NAME.POSTS_SENSOR,
        {
          params: {
            id,
          },
        },
        false
      );
    }
  };

  return (
    <VisibilitySensor
      partialVisibility
      offset={{ bottom: 400 }}
      onChange={handleChnage}
    >
      {children}
    </VisibilitySensor>
  );
};

export default Sensor;
